var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 2.116a2 2 0 0 1 1.1 0l6 1.714A2 2 0 0 1 20 5.753v5.1a11 11 0 0 1-4.606 8.95l-2.232 1.595a2 2 0 0 1-2.325 0l-2.23-1.594A11 11 0 0 1 4 10.853v-5.1A2 2 0 0 1 5.45 3.83zM12 4.039 6 5.753v5.1a9 9 0 0 0 3.769 7.324L12 19.77l2.231-1.593A9 9 0 0 0 18 10.853v-5.1L12 4.04Zm4.207 4.602a1 1 0 0 1 0 1.414l-4.151 4.151a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.444-3.444a1 1 0 0 1 1.414 0"
  })));
};
export default SvgShieldCheck;